import { PRODUCT_CATEGORY } from './category';
import { ICountryDetail } from './countries';
import { IbillingMethod, ICommentsAndObservations, Ilocation } from './global';
import { IbillingData, ORDER_COMMENT_TYPES_ENUM, PAYMENT_TYPES } from './orders';
import { IbankAccountInfo, TplatformSubscription } from './paymentDetails';
import { IProductInfo } from './products';
import { IactiveLogisticServiceConfigurationsData, TProductConfigResponse } from './product.configuration.types';

export interface IproductLocationData {
  place?: LOCATION_PLACE_TYPE | null;
  name?: string | null;
  address?: string | null;
  additionalReferences?: string | null;
  zipCode?: string | null;
  city?: string | null;
  cityId?: number | null;
  countryIdPhone?: number | null;
  phone?: string | null;
  country?: ICountryDetail | null;
  userId?: number | null;
}

export interface ILogisticServiceType {
  id: number;
  name: string;
  nameStringId: string;
  unit: string;
  description: string;
}

export interface ObjectKey<T> {
  [key: string]: T;
}
export interface IProductReference {
  id: number;
  name: string;
  sku: string;
  pills: ObjectKey<string>;
  category?: string;
  image?: string;
  brand?: string;
  brandImage?: string;
}

export interface IlogisticsRequesterData {
  userId?: number | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  phoneCountry?: ICountryDetail | null;
  email?: string | null;
}

export interface IlogisticServiceDates {
  requestDate?: string | null;
  confirmedDate?: string | null;
  inProcessDate?: string | null;
  programmedDate?: string | null;
  deliveryDate?: string | null;
  cancelledDate?: string | null;
  active?: string | null;
  delayed?: string | null;
}

export interface IlogisticServiceLocation {
  title?: string | null;
  place?: string | null;
  country: ICountryDetail;
}

export type TlogisticsPaymentTypes = 'Care' | 'Cash' | 'Agreement';

export type TlogisticServiceStatus =
  | 'por confirmar'
  | 'confirmado'
  | 'en proceso'
  | 'activo'
  | 'entregado'
  | 'cancelado';

export interface IlogisticServicePaymentData {
  paymentLink?: string | null;
  isPaymentAgreement?: boolean | null;
  paymentAgreementDate?: string | null;
  agreementInvoiceNumber?: number | null;
  isPaymentReceived?: boolean | null;
  paymentType?: TlogisticsPaymentTypes | null;
  paymentMethod?: PAYMENT_TYPES;
}

export interface IQuotesLog {
  status?: TQuoteStatus;
  date?: string;
}

export const LOGISTIC_TYPES = {
  REASSIGNMENT: 'Reasignación',
  ONBOARDING: 'Onboarding',
  WARRANTY: 'Garantia',
  DIAGNOSTIC: 'Diagnostico',
  OFFBOARDING: 'Offboarding',
  STORAGE: 'Almacenamiento',
  MOVEMENT: 'Movimiento'
} as const;

export type TlogisticType = typeof LOGISTIC_TYPES[keyof typeof LOGISTIC_TYPES];

export interface IlogisticServiceTrelloCardData {
  id?: number | null;
  logisticType?: TlogisticType | null;
  organizationName?: string | null;
  levelSubscription?: string | null;
  dates?: IlogisticServiceDates | null;
  origin?: IlogisticServiceLocation | null;
  destination?: IlogisticServiceLocation | null;
  status?: TlogisticServiceStatus | null;
  payments?: IlogisticServicePaymentData | null;
  paymentMethod?: PAYMENT_TYPES;
  numberOfTools?: number | null;
  documentUrl?: string | null;
  quoteDocumentUrl?: string;
  isLate?: boolean;
  manualQuote?: boolean;
  hasUpdatedDates?: boolean;
  addressIssue?: IAddressIssue | null;
  proofOfPaymentUrl?: string | null;
  hasPendingConfiguration?: boolean | null;
  quotesLog: IQuotesLog;
  totalUsd?: string;
  responsibleIds?: number[];
}
export type TlogisticsMovementsTypes =
  | 'inProcess'
  | 'pendings'
  | 'confirmed'
  | 'actives'
  | 'delayed'
  | 'delivered'
  | 'cancelled';

export interface IlogisticsServicesTrello {
  pendings?: IlogisticServiceTrelloCardData[];
  confirmed?: IlogisticServiceTrelloCardData[];
  actives?: IlogisticServiceTrelloCardData[];
  delayed?: IlogisticServiceTrelloCardData[];
  delivered?: IlogisticServiceTrelloCardData[];
  cancelled?: IlogisticServiceTrelloCardData[];
  inProcess?: IlogisticServiceTrelloCardData[];
}

export interface IlogisticsEstimatedDates {
  collect?: IdateRange;
  delivery?: IdateRange;
}

export interface IdateRange {
  since?: string | null;
  until?: string | null;
}

export interface IconfirmedLsStatusDto {
  paymentType?: TlogisticsPaymentTypes | null;
  paymentLink?: string | null;
  paymentAgreementDate?: string | null;
  paymentAgreementInvoiceNumber?: number | null;
}

export interface IactiveLsStatusDto {
  trackingLink?: string;
  trackingCode?: string;
  collectSince?: string;
  collectUntil?: string;
  deliverySince?: string;
  deliveryUntil?: string;
  configurations?: IactiveLogisticServiceConfigurationsData[];
  deliveryProviderName?: string | null;
  providerEmail?: string | null;
  totalOperatingExpenses?: string | number | null;
}

export interface IdeliveredLsStatusDto {
  deliveryDate?: string;
  notDeliveredProductIds?: number[];
}

export interface IInProcessStatusDto {
  deliveryProviderName?: string | null;
  providerEmail?: string | null;
  totalOperatingExpenses?: string | number | null;
}

export interface DTOupdateLogisticServiceStatus {
  status: string;
  userId: number;
  confirm?: IconfirmedLsStatusDto;
  active?: IactiveLsStatusDto;
  delivered?: IdeliveredLsStatusDto;
  inProcess?: IInProcessStatusDto;
}

export interface DTOputCommentLoogisticsService {
  comments: string;
  userId: number;
  logisticServiceId: number;
  commentType: string;
  mentions: number[];
  commentImage?: File;
}

export interface IcreateLogisticsServiceComment {
  commentType: ORDER_COMMENT_TYPES_ENUM;
  logisticServiceId: number;
  userId: number;
  comments: string;
  mentions: number[];
  commentImage?: File;
}

export type TLogisticsDocument = 'invoice' | 'proofOfPayment' | 'document' | 'quote' | 'delivery' | 'receipt';
export interface IupdateToolData {
  productId?: number;
  sku?: string;
  serial?: string;
}

export interface DTOputLogisticServicePaymentLink {
  paymentLink: string;
}

export interface IlogisticServiceDetailsOrganizationData {
  organizationId?: number | null;
  organizationName?: string | null;
  organizationDocument?: string | null;
  country?: ICountryDetail | null;
  imageUrl?: string | null;
  levelSubscription?: TplatformSubscription;
}

export interface IlogisticServiceDetailsDeliveryCollectionData {
  chosenCollectionDate?: string | null;
  collectionComment?: string | null;
  delivererName?: string | null;
  delivererPersonalId?: string | null;
  delivererPhone?: string | null;
  user?: IlogisticServiceUser;
  delivererCountryPhone?: ICountryDetail | null;
  chosenDeliveryDate?: string | null;
  deliveryComment?: string | null;
  receiverName?: string | null;
  receiverPersonalId?: string | null;
  receiverPhone?: string | null;
  receiverCountryPhone?: ICountryDetail | null;
}

export interface IlogisticServiceUser {
  email?: string;
  firstName?: string;
  lastName?: string;
  personalId?: string;
  phoneData?: { phone?: string; phoneCode?: string; phoneCountryId?: number };
  photoProfile?: string;
  userId?: number;
  minCollectionDate?: string | null;
  maxDeliveryDate?: string | null;
}

export interface IlogisticServiceDetailsToolsData {
  productId?: number | null;
  category?: PRODUCT_CATEGORY | null;
  referenceModel?: string | null;
  name?: string | null;
  image?: string | null;
  brand?: string | null;
  brandImage?: string | null;
  pills?: { [key: string]: string | null };
  serial?: string | null;
  isGeneric?: boolean;
  sku?: string | null;
  nudosCare?: string | null;
  isMarkedNotDelivered?: boolean | null;
  isAdditionalProduct?: boolean | null;
  productConfigs?: TProductConfigResponse[] | null;
  isBuyAndHold?: number;
}

export interface IlogisticServiceDetails {
  id?: number | null;
  purchaseOrder?: string | null;
  requiresPO?: boolean | null;
  title?: string | null;
  statusId?: number | null;
  statusName?: TlogisticServiceStatus | null;
  delayed?: boolean | null;
  bankAccountInfo?: IbankAccountInfo | null;
  statusStringId?: string | null;
  createdAt?: string | null;
  programmedDate?: string | null;
  confirmedDate?: string | null;
  deliveryDate?: string | null;
  cancelledDate?: string | null;
  logisticComments?: ICommentsAndObservations[] | null;
  organization?: IlogisticServiceDetailsOrganizationData | null;
  requesterUserId?: number | null;
  requester?: IlogisticsRequesterData | null;
  invoiceUrl?: string | null;
  invoiceEmissionDate?: string | null;
  proofOfPaymentUrl?: string | null;
  paymentType?: TlogisticsPaymentTypes | null;
  paymentLink?: string | null;
  paymentAgreementDate?: string | null;
  invoiceNumber?: string | null;
  collectionInfo?: IlogisticServiceDetailsDeliveryCollectionData | null;
  deliveryInfo?: IlogisticServiceDetailsDeliveryCollectionData | null;
  estimatedDates?: IlogisticsEstimatedDates | null;
  estimatedDeliveryTime?: IdateRange | null;
  trackingLink?: string | null;
  trackingCode?: string | null;
  provider?: string | null;
  documentUrl?: string | null;
  quoteDocumentUrl?: string | null;
  deliveryDocumentUrl?: string | null;
  receiptDocumentUrl?: string | null;
  originLocationId?: number | null;
  originLocation?: IproductLocationData | null;
  destinationLocationId?: number | null;
  destinationLocation?: IproductLocationData | null;
  tools?: IlogisticServiceDetailsToolsData[] | null;
  scheduledDates?: string[];
  inProcessDate?: string | null;
  providerEmail?: string | null;
  totalOperatingExpenses?: string | null | number;
  billingData?: IbillingData;
  billingCountry?: ICountryDetail;
  addressIssue?: IAddressIssue | null;
  manualQuote?: boolean;
  isLate?: boolean;
  hasUpdatedDates?: boolean;
  reports?: ILogisticReports[];
  reportNumberOfTries?: number;
  historySL?: IHistorySL[];
  isPaymentZero?: boolean;
  paymentMethod?: PAYMENT_TYPES;
  billingMethod?: IbillingMethod;
  quotesLog?: IQuotesLog;
  currency?: string | null;
  exchangeRate?: number | null;
  totalUsd?: number | string;
  total?: number | string;
  hasActiveCredit?: boolean;
  purchaseOrderUrl?: string | null;
  isPaymentAgreement?: boolean | null;
  isPaymentReceived?: boolean | null;
  paymentAgreementDays?: number | null;
  hasPendingConfiguration?: boolean;
  needInvoice?: boolean | null;
}

export interface IHistorySL {
  date?: string;
  reasonGlobalStatus?: string;
  description?: string;
  numberOfTries?: number;
  status?: string;
  tries?: IReportTries[];
  reason?: string;
}

export interface IReportTries {
  date?: string;
  numberOfTry?: number;
}

export interface IlogData {
  date: string;
  reasonGlobalStatus: string;
  reason: string;
  status: string;
}

export interface ILogisicReportLogs {
  date?: string;
  message?: string | null;
  status?: string;
  numberOfTry?: number;
}
export interface ILogisticReports {
  currentStatus?: string;
  logs?: ILogisicReportLogs[];
  message?: string;
  reason?: string;
  reasonGlobalStatus?: string;
  reasonNameStringId?: string;
  reasonNameString?: string;
  reasonType?: string;
  reasonTypeNameStringId?: string;
  reportId?: number;
}

export interface ISerialAndSKU {
  serial?: string;
  sku?: string;
}

export interface INewSerialAndSKU {
  newSerial?: string;
  newSku?: string;
}

export interface IAddressIssue {
  origin: IOriginDestinationIssue;
  destination: IOriginDestinationIssue;
}

export interface IIssueReported {
  reportSent: string;
}

export interface IEditHistory {
  date: string;
  platform: 'DASH' | 'SOGA';
  editedFields: string[];
}

export interface IOriginDestinationIssue {
  issueReported?: IIssueReported[];
  addressEdited?: boolean;
  editedBy?: string;
  viewedChanges?: boolean;
  editHistory?: IEditHistory[];
}

export interface IContactInformation {
  name: string;
  phone?: string;
  phoneCountryCode?: string;
  personalId?: string;
}

export interface IUpdateLogisticServiceAddress {
  firstName?: string;
  lastName?: string;
  personalId?: string;
  countryPhoneId?: number;
  phone?: string;
  address?: {
    address: string;
    additionalReferences: string;
    contactInformation?: IContactInformation;
    city: string;
    cityId?: number;
    zipCode: string;
    country: string;
    countryId?: number;
    coordinates?: {
      lat: string;
      lng: string;
    };
  };
  countryId?: number;
}

export interface IReportOptions {
  id: number;
  name: string;
  selected: boolean;
  value: string;
}

export type TEditField = 'phone' | 'city' | 'additionalReferences' | 'zipCode' | 'address';

export interface IEditedFieldsValue {
  address?: string;
  zipCode?: string;
  phone?: string;
  city?: string;
  additionalReferences?: string;
}

export interface IReportLogisticServiceReason {
  id?: number;
  name?: string;
  reasonType?: string;
  globalStatus?: string;
  nameStringId?: string;
  nameString?: string;
}

export interface IReportLogisticServiceProblemBody {
  userId?: number | null;
  reasonId?: number | null;
  logisticServiceId?: number | null;
  numberOfTry?: number | null;
}
export interface IReportReasonAttempt {
  value?: number;
  label?: string;
}

export interface IUploadLogisticServiceFile {
  logisticServiceId?: number | null;
  type?: TLogisticsDocument | null;
  file?: File | null;
  handleLoading?: (isLoading: boolean) => void;
  updateDataCallback?: () => void;
  billingCountryId: number;
  customSuccessMessage?: string;
}

export enum LS_REPORT_REASONS {
  ORIGIN_POINT_ADVERSE = 'ORIGIN_POINT_ADVERSE',
  DESTINATION_POINT_ADVERSE = 'DESTINATION_POINT_ADVERSE',
  UNRESPONSIVE_DELIVERY_EMPLOYEE = 'UNRESPONSIVE_DELIVERY_EMPLOYEE',
  UNRESPONSIVE_RECEIVING_EMPLOYEE = 'UNRESPONSIVE_RECEIVING_EMPLOYEE',
  AWAIT_RESPONSE = 'AWAIT_RESPONSE',
  WITHOUT_REASON = 'WITHOUT_REASON',
  HOLIDAY = 'HOLIDAY',
  EMPLOYEE_NOT_WILLING = 'EMPLOYEE_NOT_WILLING',
  EMPLOYEE_NOT_DATE_DELIVERY = 'EMPLOYEE_NOT_DATE_DELIVERY',
  EMPLOYEE_NOT_DATE_RECEIVER = 'EMPLOYEE_NOT_DATE_RECEIVER',
  CHANGE_SHIPMENT_ADDRESS = 'CHANGE_SHIPMENT_ADDRESS',
  CHANGE_SHIPMENT_DATE = 'CHANGE_SHIPMENT_DATE'
}

export interface IReportingOptions {
  id: number;
  name: 'Número de teléfono' | 'Ciudad' | 'Dirección' | 'Indicaciones' | 'Código Postal';
  nameStringId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface IReportBody {
  logisticServiceId: number;
  location: 'destination' | 'origin';
  wrongFields: number[];
}

export enum LOCATION_PLACE_TYPE {
  NUDOS = 'nudos',
  DIAGNOSTIC = 'diagnostic',
  WARRANTY = 'warranty',
  USER = 'user',
  OFFICE = 'office',
  OTHER = 'other',
  STORE = 'store',
  BORD_STORE = '.Bord Store'
}

export enum LOGISTIC_SERVICE_STATUS_NAME {
  TOCONFIRMED = 'por confirmar',
  CONFIRMED = 'confirmado',
  ACTIVE = 'activo',
  DELIVERED = 'entregado',
  CANCELLED = 'cancelado',
  INPROCESS = 'en proceso',
  DELAYED = 'atrasado'
}

export enum LOGISTIC_SERVICE_STATUS_ID {
  TOCONFIRMED = 1,
  CONFIRMED = 2,
  ACTIVE = 3,
  DELIVERED = 4,
  CANCELLED = 5,
  INPROCESS = 6
}

export enum LOGISTIC_DROPPABLE_ID {
  TOCONFIRMED_ID = 'pending-list',
  CONFIRMED_ID = 'confirm-list',
  ACTIVE_ID = 'active-list',
  DELIVERED_ID = 'delivered-list',
  CANCELLED_ID = 'cancel-list',
  INPROCESS_ID = 'inProcess-list',
  DELAYED_ID = 'delayed-list'
}

export interface ICardOriginDestination {
  droppableId?: string;
  index?: number;
}

export interface ITrello {
  destination?: ICardOriginDestination;
  source?: ICardOriginDestination;
  draggableId?: string;
}

export interface IUpdateInvoiceData {
  invoiceNumber?: string;
  invoiceEmissionDate?: string;
}
export interface IUpdateInvoiceNumbeInALogisticsService {
  logisticServiceId: number;
  invoiceNumberDetails: IUpdateInvoiceData;
}

export type TQuoteStatus = 'pending' | 'filled' | 'approved' | 'rejected';

export enum LIST_OF_QUOTE_STATUSES {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected'
}

export interface IUserId {
  userId: number;
}

export interface IupdateLsPurchaseOrder {
  logisticServiceId: number | string;
  purchaseOrder?: string | null;
}

export interface IUpdateManualQuotation {
  logisticServiceId: number | null;
  totalUsd: number;
  exchangeRate?: number | undefined;
}

export interface IfetchReplacementTools {
  place: string;
  userId?: number;
  countryCode: string;
  category: string;
  organizationId: number;
  referenceModel?: string;
  search?: string;
}

export interface IreplaceLsTools {
  logisticServiceId: number;
  organizationId: number;
  productsToReplace: IproductToReplace[];
}

export interface IproductToReplace {
  originalProductId: number;
  newProductId: number;
}
export interface IsearchReferenceProducts {
  query?: string;
  omitCanBeLoaded?: boolean;
}
export interface ILogisticServicePrice {
  id?: number | null;
  logisticServiceId?: number | null;
  currency?: string | null;
  exchangeRate?: string | null;
  subtotalServicesUsd?: string | null;
  taxServicesUsd?: string | null;
  commissionUsd?: string | null;
  commissionTaxUsd?: string | null;
  totalTaxesUsd?: string | null;
  totalUsd?: string | null;
  totalLocal?: string | null;
}

export interface ILogisticServiceProduct {
  id?: number | null;
  logisticServiceId?: number | null;
  productId?: number | null;
  logisticServiceProductPrices?: ILogisticServiceProductPrice[] | null;
  product?: IProductInfo | null;
}

export interface ILogisticServiceProductPrice {
  id?: number | null;
  logisticServiceProductId?: number | null;
  logisticServiceTypeId?: number | null;
  currency?: string | number | null;
  exchangeRate?: string | number | null;
  priceUsd?: string | number | null;
  taxValueUsd?: string | number | null;
  totalValueUsd?: string | number | null;
  totalValueLocal?: string | number | null;
  coveredByCare?: boolean | null;
  logisticServiceType?: ILogisticServiceType | null;
}

export interface IPaymentTypeInfo {
  id?: number | null;
  name?: string | null;
  nameStringId?: string | null;
}

export interface ILogisticServicePaymentInfo {
  id?: number | null;
  logisticServiceId?: number | null;
  paymentType?: string | null;
  paymentTypeId?: number | null;
  countryPaymentMethodId?: number | null;
  paymentLink?: string | null;
  isPaymentAgreement?: boolean | null;
  paymentAgreementDate?: string | null;
  invoiceNumber?: string | null;
  invoiceEmissionDate?: string | null;
  billingCountryId?: number | null;
  stripeInvoiceId?: string | null;
  isPaymentReceived?: boolean | null;
  paymentDate?: string | null;
  isPaymentZero?: boolean | null;
  paymentZeroUserId?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
  paymentTypeInfo?: IPaymentTypeInfo | null;
}

export interface ILogisticServiceWithProductPrices {
  id?: number | null;
  billingData?: IbillingData | null;
  logisticServicePrice?: ILogisticServicePrice | null;
  products?: ILogisticServiceProduct[] | null;
  quoteDocumentUrl?: string | null;
  paymentInfo?: ILogisticServicePaymentInfo | null;
  organizationData?: IOrganizationDataForPriceEdition | null;
  destinationProductLocation?: Ilocation | null;
  originProductLocation?: Ilocation | null;
}

export interface ICreateManualQuotation {
  logisticServiceId?: number | null;
  currency: string;
  previousTotalAmount?: number | null;
  newTotalAmount: number;
  reason?: string;
  changedByUserId?: number | null;
  changedAt: string;
  needInvoice: boolean;
  commissionUsd: number | string | null;
  previousQuotationUrl?: string | null;
  items: IManualQuotationItem[];
  exchangeRate?: number | string | null;
}

export interface IManualQuotationItem {
  productId?: number;
  logisticServiceProductPriceId?: number;
  currency: string;
  exchangeRate: number | string;
  priceUsd: number | string;
  taxValueUsd: number | string;
  totalValueUsd: number | string;
  coveredByCare: boolean;
  previousUnitAmount: number | string;
  newUnitAmount: number | string | null;
}

export interface IOrganizationDataForPriceEdition {
  organizationId?: number | null;
  organizationName?: string | null;
  organizationBusinessName?: string | null;
  platformSubscription?: TplatformSubscription | null;
  platformSubscriptionId?: number | null;
}

export interface IIndividualToolData {
  serial: string;
  productCondition: string;
  warranty: string;
  optionId: number;
  locationInfo: {
    place: string | null;
    placeName: string | null;
  };
  countryId: number;
  userInfo?: {
    userId: number;
    firstName: string;
    lastName: string;
  };
}

export interface IAddExternalProductReference {
  id: number;
  sku: string;
  name: string;
  category: string;
  quantity: number;
  individualToolsData: IIndividualToolData[];
}

export interface IAddExternalProductsToLogisticService {
  organizationId: number;
  logisticServiceId: number;
  references: IAddExternalProductReference[];
}

export interface IAddExternalProductsToLogisticServiceResponse {
  errors: Array<{
    serial: string;
    error: string;
  }>;
  recordsWithErrors: number;
  createdRecords: number;
  createdProductIds: number[];
  totalRecords: number;
}

export interface IUpdateDeliveryStatus {
  logisticServiceId: number;
  notDeliveredProductIds: number[];
}
